import React from 'react'
import Create from '../../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateOrderItem = props => {
  const { orderId } = props.params

  return (
    <Create
// @ts-ignore
      title='Create Order Item'
      fields={fields}
      apiPath='admin/order_items/multiply'
      successRedirectPath={`/ecommerce/orders/${orderId}/items`}
      buildMenuItems={menuItems}
      resource={{
        order_id: orderId,
        multiplier: 1
      }}
    />
  )
}

export default CreateOrderItem
